// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__2Bc07","calendarButtons":"ClockData_calendarButtons__Vl4cb"};